import { Select, SelectChangeEvent, MenuItem } from '@mui/material'
import { useRecruitStore } from 'src/stores/RecruitStore';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';

const menuProps = {
    PaperProps: {
        sx: {
          maxHeight: '200px',
          overflowY: 'auto',
          border: '1px solid #508A9C',
          paddingY :0,
          '& .MuiMenu-list': {
        paddingTop: 0,
        paddingBottom: 0,
      },
        },
      },
      TransitionProps: {
        onEntering: (menuElement: HTMLElement) => {
          menuElement.scrollTop = 0;
        },
      },
}

const sx = {
    height:46,
    width: '100%',
    textAlign:'center',
    justifyContent:'center',
    border: '1.5px solid #508A9C',
    '&.Mui-selected': {
      backgroundColor: '#EEF6F8',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& svg': {
      right: '30%',
      transform: 'translateX(50%)',
      position: 'absolute',
      pointerEvents: 'none',
    },
}

const DropBoxSx = {
    justifyContent: 'center',
    textAlign: 'center',
    height:'46px',
    borderTop : '1.5px solid #508A9C'
}

const RecruitSelectMonth = () => {
    const monthContent = [1,2,3,4,5,6,7,8,9,10,11,12]
    const setField = useRecruitStore((state)=>state.setField)
    const month = useRecruitStore((state)=>state.month)

    const handleMonthChange = (e:SelectChangeEvent<string>)=>{
        setField('month',e.target.value)
    }
  return (
      <Select
          value={month}
          onChange={handleMonthChange}
          renderValue={(selected) => `${selected}월`}
          MenuProps={menuProps}
          sx={sx}
          IconComponent={KeyboardArrowDown}
          >
          {monthContent.map((content, index) => (
              <MenuItem value={content.toString()} sx={DropBoxSx}>
                  {content}월
              </MenuItem>
          ))}
      </Select>
  )
}

export default RecruitSelectMonth